var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "index-form-item",
    {
      attrs: {
        labelText: _vm.labelName,
        labelWidth: _vm.labelWidth,
        labelPosition: _vm.labelPosition,
        textAlign: _vm.labelTextPosition,
        formType: _vm.formType,
        paddingLeft: _vm.paddingLeft
      }
    },
    [
      _c(
        "div",
        { staticClass: "form-item_input" },
        [
          _c("el-switch", {
            style: { width: _vm.width },
            attrs: { disabled: _vm.isDisabled }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e4628bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e4628bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form_item/FormItemSwitch.vue
// module id = null
// module chunks = 